import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";

type OwnerPushArgs = {
  businessId?: string | null;
  businessSlug?: string | null;
  title: string;
  body: string;
  url?: string;
  data?: Record<string, unknown>;
};

export async function sendOwnerPush(args: OwnerPushArgs): Promise<void> {
  const businessId = args.businessId ? String(args.businessId).trim() : "";
  const businessSlug = args.businessSlug ? String(args.businessSlug).trim() : "";

  if (!businessId && !businessSlug) {
    logger.warn("sendOwnerPush skipped: missing business identifier");
    return;
  }

  try {
    const { data, error } = await supabase.functions.invoke("send-push-notification", {
      body: {
        business_id: businessId || undefined,
        business_slug: businessSlug || undefined,
        payload: {
          title: args.title,
          body: args.body,
          url: args.url,
          data: args.data,
        },
      },
    });

    if (error) {
      logger.warn("sendOwnerPush failed", { error: String(error) });
      return;
    }

    const recipients = Number((data as { recipients?: number })?.recipients ?? (data as { sent?: number })?.sent ?? 0);
    if (recipients < 1) {
      logger.warn("sendOwnerPush: OneSignal reported 0 recipients", { data });
    }
  } catch (error) {
    logger.warn("sendOwnerPush crashed", { error: String(error) });
  }
}
